import SheqManagerHeader from "./components/SheqManagerHeader";

export default SheqManagerHeader;